/**
 * @file refrigerant-mapping.ts
 * @description Consolidated refrigerant data mapping with organized access patterns
 */

import { RefrigerantCode, type FluidData } from '../types';

// Import all fluid data
import R22 from './data/R22.json';
// import R32 from './data/R32.json';
import R134a from './data/R134a.json';
import R404A from './data/R404A.json';
// import R407C from './data/R407C.json';
import R410A from './data/R410A.json';
import R1234yf from './data/R1234yf.json';

/**
 * Comprehensive refrigerant data structure that maps enum values to fluid data
 * and provides organized access to all refrigerant information
 */
export const REFRIGERANTS = {
  DATA: {
    [RefrigerantCode.R22]: R22 as unknown as FluidData,
    [RefrigerantCode.R134a]: R134a as unknown as FluidData,
    [RefrigerantCode.R1234yf]: R1234yf as unknown as FluidData,
    // [RefrigerantCode.R32]: R32 as unknown as FluidData,
    [RefrigerantCode.R404A]: R404A as unknown as FluidData,
    // [RefrigerantCode.R407C]: R407C as unknown as FluidData,
    [RefrigerantCode.R410A]: R410A as unknown as FluidData
  } as Record<RefrigerantCode, FluidData>,
} as const;

